/* eslint-disable import/no-anonymous-default-export */
import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm, ChangePasswordForm, CreateAccountForm, LoginAdminForm } from './components';
import { useHistory } from 'react-router-dom';

export default function () {
  //console.log('UnauthenticatedContent Load');
  const history = useHistory();

  const handleWordClick = (e) => {
    // 클릭된 단어에 대한 처리를 여기에 추가
    history.push('/login-admin')
  };

  const handleWordClickAdmin = (e) => {
    // 클릭된 단어에 대한 처리를 여기에 추가
    history.push('/login')
  };

  return (
    <Switch>
      <Route exact path="/login">
        <SingleCard title="업소고객 관리 시스템" >
        {/* handleWordClick={handleWordClick} */}
          <LoginForm companyCode='0000000003'/>
        </SingleCard>
      </Route>
      <Route exact path="/login-admin">
        <SingleCard title="업소고객 관리 시스템 관리자" >
        {/* handleWordClick={handleWordClickAdmin} */}
          <LoginAdminForm companyCode='0000000003'/>
        </SingleCard>
      </Route>
      {/* <Route exact path="/login/ud">
        <SingleCard title="UD 법인 관리 시스템">
          <LoginForm companyCode='0000000003'/>
        </SingleCard>
      </Route>
      <Route exact path="/login/threecall">
        <SingleCard title="트리콜 법인 관리 시스템">
          <LoginForm companyCode='0000000001'/>
        </SingleCard>
      </Route> */}
      <Route exact path="/create-account">
        <SingleCard title="계정 생성">
          <CreateAccountForm />
        </SingleCard>
      </Route>
      <Route exact path="/change-password/:recoveryCode">
        <SingleCard title="Change Password">
          <ChangePasswordForm />
        </SingleCard>
      </Route>
      <Redirect to={'/login'} />
    </Switch>
  );
}
